import React from 'react';
import { AlertTriangle, RefreshCw, Save } from 'lucide-react';
import { Button, Modal } from '../ui/index.js';
import type { ConflictState } from '../../hooks/useWorkflowForm.js';

interface ConflictDialogProps {
  conflict: ConflictState;
  onReload: () => void;
  onForceSave: () => void;
}

export const ConflictDialog: React.FC<ConflictDialogProps> = ({ conflict, onReload, onForceSave }) => {
  return (
    <Modal
      open
      onClose={() => undefined}
      dismissable={false}
      title="Save conflict"
      titleIcon={<AlertTriangle size={18} className="text-warning" />}
      description="This workflow was modified since you started editing. Your changes can't be saved without resolving the conflict."
      footer={
        <div className="flex items-center justify-end gap-2">
          <Button variant="secondary" onClick={onReload}>
            <RefreshCw size={14} /> Reload server version
          </Button>
          <Button variant="danger" onClick={onForceSave}>
            <Save size={14} /> Overwrite
          </Button>
        </div>
      }
    >
      <div className="rounded-lg bg-surface-alt p-3 text-xs text-muted">
        Server version: <span className="font-mono text-body">{conflict.serverState.version ?? '?'}</span>
      </div>
    </Modal>
  );
};
